export type MarketInsightsNavigate = (
  page: string,
  clientId?: string,
  params?: { propertyId?: string }
) => void;

export function openMarketInsightsProperty(
  onNavigate: MarketInsightsNavigate | undefined,
  propertyId: string
): void {
  if (!onNavigate || !propertyId) return;
  onNavigate("properties", undefined, { propertyId });
}
